import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { getFormattedTime } from 'webapp/utils/number';

import Serviced from 'webapp/models-custom/serviced';

export interface ConnectRequestData {
	dataSourceTypeId: number;
	flashToken: string;
	requesteeEmail: string;
	requestorId: number;
	requestorName: string;
	requestedOn: number;
}

export default class ConnectRequest extends Serviced {
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('model-manager/source-types')
	declare mmSourceTypesService: Service.ModelManager.SourceTypes;

	dataSourceTypeId: ConnectRequestData['dataSourceTypeId'];
	flashToken: ConnectRequestData['flashToken'];
	requesteeEmail: ConnectRequestData['requesteeEmail'];
	requestorId: ConnectRequestData['requestorId'];
	requestorName: ConnectRequestData['requestorName'];
	requestedOn: ConnectRequestData['requestedOn'];

	isConnectRequest = true as const; // used when filtering sources in the datamanager-connected
	declare isConnectSelection?: false; // tells it apart from a ConnectSelection in that list
	declare activeFilter?: string[]; // set by the filter-sort, like on sources

	constructor(connectRequestData: ConnectRequestData) {
		super();

		this.dataSourceTypeId = connectRequestData.dataSourceTypeId;
		this.flashToken = connectRequestData.flashToken;
		this.requesteeEmail = connectRequestData.requesteeEmail;
		this.requestorId = connectRequestData.requestorId;
		this.requestorName = connectRequestData.requestorName;
		this.requestedOn = connectRequestData.requestedOn;
	}

	// the source list's creator filter reads these, as on a source
	get createdById() {
		return this.requestorId;
	}

	get isMine() {
		return this.requestorId === this.currentUserService.numericId;
	}

	get sourceType() {
		return this.mmSourceTypesService.findModelById(this.dataSourceTypeId);
	}

	get requestedOnText() {
		return (
			'<span>Requested on ' +
			getFormattedTime(this.requestedOn, this.currentUserService.model?.timezone) +
			'</span><br> by ' +
			this.requestorName
		);
	}

	get requestSentText() {
		return (
			'Request sent to ' +
			this.requesteeEmail +
			' on ' +
			getFormattedTime(
				this.requestedOn,
				this.currentUserService.model?.timezone,
				'MMM D, YYYY [at] hh:mm A',
			)
		);
	}
}
